import { FleetUUIDs } from '../enums';
import { useFleet } from './useFleet';

export const useTranslatedBlockName = () => {
  const fleet = useFleet();

  return fleet.uuid === FleetUUIDs.AthensEuPilotEnv || fleet.uuid === FleetUUIDs.AthensEuProdEnv;
};
